import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { combineLatest, Observable, Subscription } from 'rxjs';
import { HelpdeskOptionsContext } from '../../../helpdesk/shared/contexts/helpdesk-options.context';
import { AuthenticationContext } from '../../../shared/contexts/authentication.context';
import { map } from 'rxjs/operators';
import { CurrentUser, ZpmPrivilege } from '../../../shared/models/generated/ziroModels';

@Component({
  selector: 'ziro-order-view-and-edit-container',
  templateUrl: './order-view-and-edit-container.component.html',
  standalone: false,
})
export class OrderViewAndEditContainerComponent implements OnInit, OnDestroy {
  private _helpdeskOptionsContext = inject(HelpdeskOptionsContext);
  private _authenticationContext = inject(AuthenticationContext);

  isLoading = true;
  companyId: string;
  isSupportUser: boolean;
  currentUser: CurrentUser;

  private _subscriptions = new Subscription();

  ngOnInit(): void {
    const subs = combineLatest([this._getIsSupportUser(), this._getHelpdeskOptions()]).subscribe(() => {
      this.isLoading = false;
    });
    this._subscriptions.add(subs);
  }

  ngOnDestroy(): void {
    this._subscriptions.unsubscribe();
  }

  private _getHelpdeskOptions(): Observable<void> {
    return this._helpdeskOptionsContext.state$.pipe(
      map((state) => {
        if (this._helpdeskOptionsContext.isMicrosoftHelpdeskOptions(state)) {
          this.companyId = state.companyId;
        }
      }),
    );
  }

  private _getIsSupportUser(): Observable<void> {
    return this._authenticationContext.state$.pipe(
      map((user) => {
        this.isSupportUser = this._authenticationContext.userHasPrivilege(user, ZpmPrivilege.ZIRO_SUPPORT_SETTINGS);
        this.currentUser = user;
      }),
    );
  }
}
